import { defineRegistry } from "@json-render/react";
import { vizRuntimeCatalog } from "@/lib/ai/visualization/catalog";
import type { VizComponentName } from "@/lib/ai/visualization/views/component-schemas";
import { BarComparison } from "./bar-comparison";
import { BarRanking } from "./bar-ranking";
import { ScatterPlot } from "./scatter-plot";
import { TimeSeriesArea } from "./time-series-area";
import { TimeSeriesComposed } from "./time-series-composed";
import { TimeSeriesLine } from "./time-series-line";
import { VizCard } from "./viz-card";
import { VizTable } from "./viz-table";

// client 側 registry は catalog と同じ component 集合を必ず実装する。
export const vizRegistryComponents = {
  VizCard,
  BarRanking,
  BarComparison,
  TimeSeriesLine,
  TimeSeriesGroupedLine: TimeSeriesLine,
  TimeSeriesArea,
  TimeSeriesComposed,
  ScatterPlot,
  VizTable,
} satisfies Record<VizComponentName, unknown>;

export const { registry: vizComponentRegistry } = defineRegistry(
  vizRuntimeCatalog,
  {
    components: vizRegistryComponents,
  },
);
